###
  Wrapper of InlineMessage class that allows to show inline messages manually
###

(($) ->

  $.fn.extend

    clearMessage: () ->
      return @.each (key, element) =>
        return INTENT.utils.InlineMessage.clearMessage element

    showError: (text) ->
      return @.each (key, element) =>
        INTENT.utils.InlineMessage.showMessage element, 'error', text

    showWarning: (text) ->
      return @.each (key, element) =>
        INTENT.utils.InlineMessage.showMessage element, 'warning', text

    showInfo: (text) ->
      return @.each (key, element) =>
        INTENT.utils.InlineMessage.showMessage element, 'info', text

    showSuccess: (text) ->
      return @.each (key, element) =>
        INTENT.utils.InlineMessage.showMessage element, 'success', text

) jQuery